<template>
    <v-dialog :value="dialog" max-width="500px" persistent scrollable :fullscreen="ehMobile">
        <v-card class="co-novo-contato" :disabled="loading">
            <v-card-title class="title primary--text mb-6">
                <span v-if="ehNovoCadastro">Novo Cadastro</span>
                <span v-else>Editar Cadastro</span>
                <v-spacer/>
                <v-icon color="primary" @click="fechar"> mdi-window-close </v-icon>
            </v-card-title>

            <form @submit.prevent="salvar" class="mx-3" data-vv-scope="form-novo-contato">
                <v-card-text class="campos">
                    <nome-signatario
                        v-if="!ehObservador"
                        v-model="cadastroSignatario"
                        title-case
                        :campo-requerido="!ehObservador"
                        form-scope="form-novo-contato"
                    />

                    <tipo-assinatura-formulario
                        v-if="!ehObservador"
                        v-model="cadastroSignatario"
                        :tipos-assinatura="tiposAssinatura"
                        :campo-requerido="!ehObservador"
                        form-scope="form-novo-contato"
                    />

                    <email-signatario
                        v-model="cadastroSignatario"
                        :campo-requerido="ehObservador || !ehAssinaturaWhatsapp"
                        form-scope="form-novo-contato"
                    />

                    <telefone-signatario-novo
                        v-if="!ehObservador"
                        v-model="cadastroSignatario"
                        :campo-requerido="!ehObservador && ehAssinaturaWhatsapp"
                        form-scope="form-novo-contato"
                    />

                    <documento-signatario
                        v-if="!ehObservador"
                        v-model="cadastroSignatario"
                        :documentos="documentosSignatario"
                        :campo-requerido="!ehObservador"
                        form-scope="form-novo-contato"
                    />

                    <papel-signatario
                        v-if="!ehObservador"
                        v-model="cadastroSignatario"
                        :papeis="papeisSignatario"
                        :campo-requerido="!ehObservador"
                        form-scope="form-novo-contato"
                    />

                    <lista-grupos-selecionaveis
                        v-model="cadastroSignatario"
                        :grupos="gruposSignatarios"
                    />

                    <switch-solicitar-telefone-assinatura
                        v-if="!ehObservador"
                        class="mb-2"
                        label="Solicitar telefone na assinatura"
                        :informacao="labelInformacaoSolicitarTelefone"
                        v-model="cadastroSignatario"
                    />

                    <switch-solicitar-token-validacao
                        v-if="!ehObservador"
                        class="mb-2"
                        label="Solicitar token de verificação enviado por e-mail"
                        v-model="cadastroSignatario"
                        :desabilitarCampo="ehPlanoFree"
                    />

                    <switch-solicitar-selfie-assinatura
                        v-if="!ehObservador"
                        class="mb-2"
                        label="Solicitar selfie"
                        v-model="cadastroSignatario"
                        :informacao="labelInformacaoSolicitarSelfie"
                    />

                    <switch-observador
                        label="Definir como observador"
                        :informacao="labelInformacaoObservador"
                        v-model="cadastroSignatario"
                    />
                </v-card-text>

                <v-divider/>
                <v-card-actions class="mx-3 my-2">
                    <v-btn class="cancelar" depressed outlined @click="fechar">
                        CANCELAR
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" type="submit" depressed :loading="loading">
                        SALVAR
                    </v-btn>
                </v-card-actions>
            </form>
        </v-card>
    </v-dialog>
</template>

<script>
import {actionTypes} from '@/commons/constants'
import {mapState, mapGetters} from 'vuex'
import NomeSignatario
    from '@/views/visualizar-contrato/barra-lateral/assinaturas/components/adicionar-signatario/components/campos-formulario/NomeSignatario'
import EmailSignatario
    from '@/views/visualizar-contrato/barra-lateral/assinaturas/components/adicionar-signatario/components/campos-formulario/EmailSignatario'
import DocumentoSignatario
    from '@/views/visualizar-contrato/barra-lateral/assinaturas/components/adicionar-signatario/components/campos-formulario/DocumentoSignatario'
import PapelSignatario
    from '@/views/visualizar-contrato/barra-lateral/assinaturas/components/adicionar-signatario/components/campos-formulario/PapelSignatario'
import ListaGruposSelecionaveis from './components/ListaGruposSelecionaveis'
import TipoAssinaturaFormulario
    from '@/views/visualizar-contrato/barra-lateral/assinaturas/components/adicionar-signatario/components/campos-formulario/TipoAssinatura'
import TelefoneSignatarioNovo
    from '@/views/criar-documento/novo-documento-signatario/components/dados-principais/components/TelefoneSignatarioNovo'
import SwitchObservador
    from '@/views/visualizar-contrato/barra-lateral/assinaturas/components/adicionar-signatario/components/campos-formulario/SwitchObservador'
import SwitchSolicitarTelefoneAssinatura
    from '@/views/visualizar-contrato/barra-lateral/assinaturas/components/adicionar-signatario/components/campos-formulario/SwitchSolicitarTelefoneAssinatura'
import SwitchSolicitarTokenValidacao
    from '@/views/visualizar-contrato/barra-lateral/assinaturas/components/adicionar-signatario/components/campos-formulario/SwitchSolicitarTokenValidacao'
import SwitchSolicitarSelfieAssinatura
    from '@/views/visualizar-contrato/barra-lateral/assinaturas/components/adicionar-signatario/components/campos-formulario/SwitchSolicitarSelfieAssinatura'

export default {
    name: 'DialogNovoContato',
    components: {
        TipoAssinaturaFormulario,
        ListaGruposSelecionaveis,
        NomeSignatario,
        EmailSignatario,
        TelefoneSignatarioNovo,
        DocumentoSignatario,
        PapelSignatario,
        SwitchObservador,
        SwitchSolicitarTelefoneAssinatura,
        SwitchSolicitarTokenValidacao,
        SwitchSolicitarSelfieAssinatura
    },
    props: {
        dialog: {
            type: Boolean,
            required: true
        },
        cadastroSignatario: {
            type: Object,
        },
        documentosSignatario: {
            type: Array,
        },
        gruposSignatarios: {
            type: Array,
        },
        papeisSignatario: {
            type: Array,
        },
    },
    data() {
        return {
            tiposAssinatura: [
                {id: 'ELETRONICA', nome: 'Assinatura Eletrônica'},
                {id: 'DIGITAL', nome: 'Assinatura Digital'},
                //{id: 'WHATSAPP', nome: 'Assinatura Whatsapp'}
            ],
            loading: false,
        }
    },
    computed: {
        ...mapGetters(['ehPlanoFree']),
        ...mapState(['login']),
        assinaturaDigital() {
            return this.login.funcionalidadesOrganizacao.assinaturaDigital
        },
        ehNovoCadastro() {
            return this.cadastroSignatario.id === null
        },
        ehAssinaturaWhatsapp() {
            return this.cadastroSignatario.tipoAssinatura === 'WHATSAPP'
        },
        ehEmailVazio() {
            return this.cadastroSignatario.email === undefined || this.cadastroSignatario.email === null || this.cadastroSignatario.email === ''
        },
        ehPapelVazio() {
            return !this.cadastroSignatario.papelId
        },
        ehTipoAssinaturaVazio() {
            return !this.cadastroSignatario.tipoAssinatura
        },
        ehDocumentoVazio() {
            return !this.cadastroSignatario.documentoId
        },
        ehTelefoneVazio() {
            return this.cadastroSignatario.telefone === undefined || this.cadastroSignatario.telefone === null || this.cadastroSignatario.telefone === ''
        },
        ehObservador() {
            return this.cadastroSignatario.observador
        },
        labelInformacaoObservador() {
            return `O e-mail informado não assinará o ${this.$tc('pt_br.documento').toLowerCase()}. Receberá apenas uma notificação quando o ${this.$tc('pt_br.documento').toLowerCase()} for formalizado.`
        },
        labelInformacaoSolicitarTelefone() {
            return `O telefone será solicitado para conclusão de assinatura do ${this.$tc('pt_br.documento').toLowerCase()}.`
        },
        labelInformacaoSolicitarSelfie() {
            return `Solicitará obrigatoriamente ao ${this.$tc('pt_br.signatario').toLowerCase()} tirar uma selfie para conclusão da assinatura.`
        },
        ehMobile() {
            return this.$vuetify.breakpoint.xs
        }
    },
    created() {
        this.possuiAssinaturaDigital()
    },
    methods: {
        fechar() {
            this.$emit('fechar')
        },
        possuiAssinaturaDigital() {
            if (!this.assinaturaDigital) {
                this.tiposAssinatura.splice(1, 1)
            }
        },
        async salvar() {
            const formValido = await this.$validator._base.validateAll('form-novo-contato')

            if (!formValido) return

            if (this.ehNovoCadastro) {
                await this.salvarCadastro()
            } else {
                await this.salvarEdicao()
            }
        },
        async salvarCadastro() {
            try {
                this.loading = true
                this.setMensagemLoading(`Salvando ${this.$tc("pt_br.signatario").toLowerCase()}...`)
                let cadastroNovo = await this.$store.dispatch(actionTypes.CADASTRO_SIGNATARIOS.INSERIR_CADASTRO_SIGNATARIO, {
                    cadastroSignatario: this.cadastroSignatario
                })
                if (cadastroNovo.sucesso) {
                    this.mostrarNotificacaoSucessoDefault()
                    this.$emit('salvar')
                } else {
                    this.mostrarNotificacaoErro(this.tratarMensagemErro(cadastroNovo.mensagem))
                }
                this.loading = false
            } catch (e) {
                this.loading = false
            }
        },
        async salvarEdicao() {
            try {
                this.loading = true
                this.setMensagemLoading('Salvando alteração...')
                let cadastroAtualizado = await this.$store.dispatch(actionTypes.CADASTRO_SIGNATARIOS.ATUALIZAR_CADASTRO_SIGNATARIO, {
                    cadastroSignatario: this.cadastroSignatario
                })
                if (cadastroAtualizado.sucesso) {
                    this.mostrarNotificacaoSucessoDefault()
                    this.$emit('salvar')
                } else {
                    this.mostrarNotificacaoErro(this.tratarMensagemErro(cadastroAtualizado.mensagem))
                }
                this.loading = false
            } catch (e) {
                this.loading = false
            }
        },
        tratarMensagemErro(mensagem) {
            return mensagem.slice(2, -2)
        }
    }
}
</script>

<style lang="stylus">
.co-novo-contato
    background-color: var(--background-100)
    height 100%
    overflow-y auto

    .cancelar
        color var(--text-color-200)

</style>
